import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import {store} from './store/store';
import {i18n} from './plugins/i18n';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import VueLazyload from 'vue-lazyload'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faArrowCircleUp } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faArrowCircleUp)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(VueLazyload);
window.$ = require('jquery');

Vue.use(VueAxios, axios);
axios.defaults.baseURL = process.env.VUE_APP_BASE_API;

Vue.use(VueAwesomeSwiper);

import router from './router'

Vue.config.productionTip = false;

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app');

